import React, {useEffect, useState} from 'react';
import globalContext from '../../../../config/context';

import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 300,
    marginTop: 5,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
}));

const DialogZoom = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{zoomKelurahan, zoomBlok, zoomPersil}, {setZoomKelurahan, setZoomBlok, setZoomPersil}] = useAppContext();
  const {
    onZoom,
    validZoomKelurahan,
    validZoomBlok,
    validZoomPersil,
    setValidZoomKelurahan,
    setValidZoomBlok,
    setValidZoomPersil,
  } = props;

  return (
    <div className={classes.root}>
      <TextField
        // disabled={true}
        id="outlined-basic"
        className={classes.textField}
        label="Zoom Kelurahan"
        variant="outlined"
        type="number"
        value={zoomKelurahan}
        helperText={validZoomKelurahan}
        error={validZoomKelurahan !== null}
        onChange={(e) => {
          setZoomKelurahan(e.target.value);
          if (e.target.value >= zoomBlok) {
            setValidZoomKelurahan('Tidak boleh melebihi Zoom Blok');
          } else if (e.target.value <= 0) {
            setValidZoomKelurahan('Tidak boleh 0');
          } else {
            setValidZoomKelurahan(null);
          }
        }}
      />

      <TextField
        // disabled={true}
        id="outlined-basic"
        className={classes.textField}
        label="Zoom Blok"
        variant="outlined"
        type="number"
        value={zoomBlok}
        helperText={validZoomBlok}
        error={validZoomBlok !== null}
        onChange={(e) => {
          setZoomBlok(e.target.value);
          if (e.target.value >= zoomPersil) {
            setValidZoomBlok('Tidak boleh melebihi Zoom Persil');
          } else if (e.target.value <= zoomKelurahan) {
            setValidZoomBlok('Tidak boleh melebihi Zoom Kelurahan');
          } else {
            setValidZoomBlok(null);
          }
        }}
      />

      <TextField
        id="outlined-basic"
        className={classes.textField}
        label="Zoom Persil"
        variant="outlined"
        type="number"
        value={zoomPersil}
        helperText={validZoomPersil}
        error={validZoomPersil !== null}
        onChange={(e) => {
          setZoomPersil(e.target.value);
          if (e.target.value >= 18) {
            setValidZoomPersil('Tidak boleh melebihi 17');
          } else if (e.target.value <= zoomBlok) {
            setValidZoomPersil('Tidak boleh melebihi Zoom Blok');
          } else {
            setValidZoomPersil(null);
          }
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            if (validZoomKelurahan === null && validZoomBlok === null && validZoomPersil === null) {
              onZoom();
            }
          }
        }}
      />
    </div>
  );
};

export default DialogZoom;
